/**
 * Parse UTM parameters from URL by mask: utm_* and extra parameters: manager, keywords, ref_id
 *
 * @param url Full URL with host
 */
export const parseUtmParameters = (url?: string) => {
  if (!url) {
    return {}
  }

  const parsedUrl = new URL(url)
  const searchParameters = parsedUrl.searchParams
  const utmParameters: Record<string, string> = {}

  // Check for ref_id and initConfig utm parameters accordingly
  if (searchParameters.has('ref_id')) {
    utmParameters['source'] = 'referral'
    utmParameters['utm_source'] = 'referral'
    utmParameters['utm_medium'] = 'link'
    utmParameters['utm_campaign'] = searchParameters.get('ref_id') || ''
  }

  // Parse other utm_* parameters and additional parameters like manager and keywords
  for (const [key, value] of searchParameters) {
    if (key.startsWith('utm_') || key === 'manager' || key === 'keyword' || key === 'ref_id' || key === 'source') {
      utmParameters[key] = value
    }
  }

  return utmParameters
}
